import postRobot from 'post-robot';
import { saveUatStatus } from 'orch-communicator/store';

postRobot.on(
  'visa-communicator:internal:uat-status',
  { domain: '*' },
  (event: { data: { uatStatus: boolean } }) => {
    saveUatStatus(event.data.uatStatus);
  }
);
